//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridGridCommon } from '../../../../Components/BusinessGridGridCommon';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import {
  Tooltip,
  tooltipClasses,
  Typography,
  Paper,
  Button,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Button as GridButton, Dialog } from '../../../../Components/MUIs';
import { Download as DownloadIcon } from '@mui/icons-material';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useSelector } from 'react-redux';

function TRA_BASIC_01(props) {
  // 현재 클릭된 행의 TBM_CD를 추적하기 위한 ref
  const clickedTbmCdRef = React.useRef(null);
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 교육현황  그리드 컬럼
  const LargeTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#4CAF50', // 본체 배경 초록
      color: '#fff',
      fontSize: '0.9rem',
      padding: theme.spacing(1),
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#4CAF50', // 꼬리도 동일 색으로!
    },
  }));

  const columnDefs1 = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: 'no',
      headerName: 'NO',
      maxWidth: 80,
      cellStyle: { textAlign: 'right' },
      editable: false,
    },
    {
      field: 'TBM_CD',
      headerName: 'TBM코드',
      width: 200,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'TBM_TITLE',
      headerName: '주제',
      width: 200,
      editable: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    // {
    //   field: 'TBM_COMMENT',
    //   headerName: '내용',
    //   width: 180,
    //   editable: true,
    //   cellStyle: {
    //     display: 'flex',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //   }, // 셀 자체 왼쪽 정렬
    // },
    {
      field: 'TBM_DATE',
      headerName: '일자',
      width: 110,
      editable: false,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '';

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 1을 더해서 월을 1-12로 맞추고, 2자리로 포맷
        const day = date.getDate().toString().padStart(2, '0'); // 일자도 2자리로 포맷

        return `${year}-${month}-${day}`;
      },
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'not-allowed',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'TBM_START_DATE',
      headerName: '시작',
      width: 80,
      editable: false,
      valueFormatter: (params) => {
        if (!params.value) return '';
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '';

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
      },
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'not-allowed',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'TBM_END_DATE',
      headerName: '종료',
      width: 80,
      editable: false,
      valueFormatter: (params) => {
        if (!params.value) return '';
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '';

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
      },
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'not-allowed',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'TBM_ADD_DATE',
      headerName: '실시 시간(분)',
      width: 150,
      editable: false,
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        cursor: 'not-allowed',
      }, // 셀 자체 오른쪽 정렬
      valueFormatter: (params) => {
        if (!params.data) return '0분';

        const seconds = Number(params.data.TBM_ADD_DATE);
        if (isNaN(seconds) || seconds === 0) return '0분';

        const minutes = Math.floor(seconds / 60);
        if (minutes <= 0) return '0분';

        const hours = Math.floor(minutes / 60);
        const remainMin = minutes % 60;

        let result = '';
        if (hours > 0) result += `${hours}시간 `;
        if (remainMin > 0) result += `${remainMin}분`;
        return result.trim();
      },
    },
    {
      field: 'TBM_ADDRESS',
      headerName: '장소',
      width: 100,
      editable: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'USER_LIST',
      headerName: '참석 인원',
      width: 120,
      editable: false,
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'not-allowed',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'USER_CNT',
      headerName: '총원',
      width: 100,
      editable: false,
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'not-allowed',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'SITE_NM',
      headerName: '강사',
      width: 110,
      editable: false,
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'not-allowed',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'REMARK',
      headerName: '비고',
      width: 110,
      editable: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'TBM_FILE',
      headerName: 'TBM 회의 자료',
      headerComponentParams: {
        template:
          '<div class="ag-header-cell-label"><span>TBM<br>회의 자료</span></div>',
      },
      width: 110,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
      cellRenderer: (e) => {
        return (
          <LargeTooltip title={'자료 보기'} arrow placement="top">
            <span>
              <GridButton
                size="small"
                name={'자료 보기'}
                sx={{ width: '100%' }}
                onClick={() => {
                  props.PopupClickEvent1(e.data);
                }}
              />
            </span>
          </LargeTooltip>
        );
      },
    },
  ];

  // 참석자정보 그리드 컬럼
  const columnDefs2 = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: 'no',
      headerName: 'NO',
      maxWidth: 80,
      cellStyle: { textAlign: 'right' },
      editable: false,
    },
    {
      field: 'TBM_CD',
      headerName: 'TBM코드',
      width: 200,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'DEP_NM1',
      headerName: '본부',
      width: 110,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'DEP_NM2',
      headerName: '부서',
      width: 110,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'DEP_NM3',
      headerName: '팀',
      width: 110,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'DEP_NM4',
      headerName: '파트',
      width: 110,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'USER_NM',
      headerName: '참석자명',
      flex: 1,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
  ];

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick1) {
      if (!props.validateSelection()) {
        props.setFilterClick1(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick1(false);
    }
    if (props.searchClick1) {
      props.ResetLogic1();
      props.ResetLogic2();
      if (!props.validateSelection()) {
        props.setSearchClick1(false);
        return;
      }

      props.SearchLogic1(searchInfo.custCd);
      props.setSearchClick1(false);
    }
    if (props.addClick1) {
      if (!props.validateSelection()) {
        props.setAddClick1(false);
        return;
      }

      GridFunctions.addClick(props.gridRef1);
      props.setAddClick1(false);
    }
    if (props.saveClick1) {
      if (!props.validateSelection()) {
        props.setSaveClick1(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick1(false);
    }
    if (props.deleteClick1) {
      if (!props.validateSelection()) {
        props.setDeleteClick1(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick1(false);
    }
    if (props.printClick1) {
      if (!props.validateSelection()) {
        props.setPrintClick1(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick1(false);
    }
    if (props.listClick1) {
      if (!props.validateSelection()) {
        props.setListClick1(false);
        return;
      }

      props.setModalToggle3(true);
      props.SearchLogic4();
      props.setListClick1(false);
    }
  }, [
    props.filterClick1,
    props.searchClick1,
    props.addClick1,
    props.saveClick1,
    props.deleteClick1,
    props.printClick1,
    props.listClick1,
  ]);
  //#endregion

  return (
    <React.Fragment>
      <BusinessGridGridCommon
        getRowId={(params) => {
          return params.data.RS_CD;
        }}
        title1={'교육현황'}
        title2={'참석자 정보'}
        addYn1="N"
        addYn2="N"
        deleteYn1="N"
        deleteYn2="N"
        leftSize={60}
        rightSize={40}
        gridRef1={props.gridRef1}
        gridRef2={props.gridRef2}
        columnDefs1={columnDefs1}
        columnDefs2={columnDefs2}
        rowData1={props.rowData1}
        rowData2={props.rowData2}
        setSelectedRowData1={props.setSelectedRowData1}
        setSelectedRowData2={props.setSelectedRowData2}
        setChangedRowData1={props.setChangedRowData1}
        setChangedRowData2={props.setChangedRowData2}
        onCellClicked1={(e) => {
          const currentTbmCd = e.data.TBM_CD;
          // 이미 클릭된 행을 다시 클릭한 경우 조회하지 않음
          if (clickedTbmCdRef.current === currentTbmCd) {
            return;
          }
          // 새로운 행을 클릭한 경우에만 조회
          clickedTbmCdRef.current = currentTbmCd;
          props.tbmCdRef.current = currentTbmCd;
          props.SearchLogic2(props.tbmCdRef.current);
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1(
            searchInfo.custCd,
            searchInfo.startDate,
            searchInfo.endDate
          );
        }}
        refreshClick2={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic2(props.tbmCdRef.current);
        }}
        // rowSelection={'muiltiple'}
      />
      {props.modalToggle1 && (
        <Dialog
          title={'파일 업로드'}
          open={props.modalToggle1}
          onClose={() => {
            props.setModalToggle1(false); // 모달 닫기
          }}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          //saveButtonName={'확인'}
          closeButtonName={'닫기'}
          //useSaveButton={true}
          useSaveAfterClose={true}
          maxWidth={false}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              padding: 2,
              width: '50%',
            },
          }}
          previewRender={props.PreviewRender}
          onSave={() => {
            const api = props.gridRef1?.current?.api;
            const clickedRowData = props.rowClickData.current;
            const uploadedFile = props.previewUrl?.file;

            if (!api || !clickedRowData || !uploadedFile?.name) {
              console.warn('파일명 또는 선택된 행이 없습니다.');
              return;
            }

            let targetRowNode = null;
            api.forEachNode((node) => {
              if (node.data === clickedRowData) {
                targetRowNode = node;
              }
            });

            if (targetRowNode) {
              const fileName = uploadedFile.name;

              targetRowNode.setDataValue('FILE_NAME', fileName);
              targetRowNode.setDataValue('mapFile', uploadedFile);
            } else {
              console.warn('대상 행을 찾을 수 없습니다.');
            }

            // 모달 닫기 및 상태 초기화
            props.setModalToggle1(false);
            props.setPreviewFile(null);
          }}
          content={
            <Box
              sx={{
                height: 'calc(100vh - 130px)',
                display: 'flex',
                flexDirection: 'column',
                p: 2,
                gap: 2,
              }}
            >
              {/* 상단 영역 */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '2rem',
                  px: 2,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Typography>
                    회의 녹음 파일 :{' '}
                    {props.audioUrl
                      ? props.audioUrl.split('/').pop()
                      : '파일 없음'}
                  </Typography>
                  <Button
                    variant="contained"
                    color="success"
                    disabled={!props.selectedRowData1?.[0]?.TBM_ADD_MEETING}
                    onClick={() =>
                      props.DownloadLogic1(
                        props.selectedRowData1?.[0]?.TBM_ADD_MEETING
                      )
                    }
                  >
                    <DownloadIcon fontSize={''} />
                    파일 다운로드
                  </Button>
                </Box>
                <AudioPlayer
                  src={props.audioUrl}
                  autoPlay={false}
                  customAdditionalControls={[]} // 불필요한 버튼 제거
                  style={{ width: '100%' }}
                />
              </Box>

              {/* 미리보기 영역 */}
              <Paper
                sx={{
                  p: 2,
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                }}
              >
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  미리보기
                </Typography>
                <Box
                  sx={{
                    border: '1px dashed #ccc',
                    borderRadius: 1,
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                  }}
                >
                  {props.PreviewRender
                    ? props.PreviewRender()
                    : '미리보기 영역'}
                </Box>
              </Paper>
            </Box>
          }
        />
      )}
    </React.Fragment>
  );
}

export default TRA_BASIC_01;
